// extracted by mini-css-extract-plugin
export default {"root":"sidebar_root__8T-Cg","close":"sidebar_close__RIKW8"};